import { INavItemProps } from 'components/atoms/NavItem'
import NavItems from 'components/atoms/NavItems'
import * as React from 'react'
import I18n from '../../core/i18n'

interface IProps {
  active: string
}

const options = { scope: 'activerecord.models' }
const Nav: React.FC<IProps> = props => {
  const navItemGen = (key, path, active?) => ({
    label: I18n.t(key, options),
    href: `/admin/${path}`,
    active: props.active === (active || key),
  })

  const navItems: INavItemProps[] = [
    navItemGen('post', 'posts'),
    navItemGen('area', 'areas'),
    navItemGen('feature', 'features'),
    navItemGen('category', 'categories'),
    navItemGen('tag', 'tags'),
    navItemGen('user', 'users'),
    navItemGen('review', 'reviews'),
    {
      label: I18n.t('generic.tour_groups'),
      href: '/admin/tours',
      active: props.active === 'tours',
    },
    navItemGen('contact', 'contacts'),
    navItemGen('identification', 'identifications', 'identifications'),
    navItemGen('setting', 'setting'),
    navItemGen('promotion', 'promotions'),
    navItemGen('coupon', 'coupons'),
    navItemGen('pickup', 'pickups'),
    {
      label: I18n.t('page', options),
      href: '/admin/pages',
      active: props.active === 'pages',
    },
  ]

  return <NavItems navItemArray={navItems} />
}

export default Nav
